module.exports = __webpack_public_path__ + "static/media/COMFORTAA-BOLD.7695aeab.TTF";